import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import '../../EventLog/components/event-log-page.scss';
import { Icons } from '../../../components/base/BootstrapComponents';
import { getUserActionData } from '../reducer';
import { loadUserActionList } from '../actions';
import TextInput from '../../../components/fields/TextInput/TextInput';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import UserActionLogGrid from './UserActionLogGrid';
import {
  getPaginationOpts,
  useUpdatePeriod,
  getJsonFromStorage,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import Loader from '../../../components/base/Loader/Loader';
import ModuleUnavailableState from '../../../components/base/ModuleUnavailableState';
import { isMenuUnavailable } from '../../System/serviceAvailability';

export function UserActionLogContent({ withHeader = true }) {
  const dispatch = useDispatch();

  const defaultFilterValues = {
    search: '',
  };

  const { updatePeriod, serviceAvailability } = useSelector(getSystemData);
  const { userActionList, userActionListMeta, loadingUserActionList } = useSelector(getUserActionData);
  const isModuleUnavailable = isMenuUnavailable(serviceAvailability, 'menu.user-action-log');

  const initial = getJsonFromStorage('ual-filter', defaultFilterValues);

  const {
    control, getValues, watch,
  } = useForm({ defaultValues: initial });

  const loadData = opts => {
    if (isModuleUnavailable) {
      return Promise.resolve([]);
    }

    const filterData = getValues();
    const paginationOpts = getPaginationOpts(userActionListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };

    const p1 = dispatch(loadUserActionList(requestData)).catch(() => {});

    return Promise.all([p1]);
  };

  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);

  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => {
      loadData();
      localStorage.setItem('ual-filter', JSON.stringify(values));
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <div className={`event-log-page${withHeader ? '' : ' embedded'}`}>
      <div className="elp-container">
        <div className="elp-inputs-box">
          {withHeader ? (
            <PageHeader header="Журнал действий пользователей">
              <div className="header-loader"><Loader loading={loadingUserActionList} /></div>
            </PageHeader>
          ) : null}
          <div className="elp-inputs">
            <FieldDTO
              control={control}
              inputBefore={<Icons customIcon className="search-icon" width={24} height={24} icon="search" />}
              type="text"
              component={TextInput}
              addPlaceholder
              dtoObject={{
                name: 'search',
                type: String,
                validators: [],
                labelKey: 'search',
              }}
              className="small no-border search-field"
            />
            {!withHeader ? <div className="header-loader"><Loader loading={loadingUserActionList} /></div> : null}
          </div>
        </div>
        {isModuleUnavailable ? <ModuleUnavailableState /> : null}
        {!isModuleUnavailable ? <UserActionLogGrid data={userActionList} meta={userActionListMeta} loadData={loadData} /> : null}
      </div>
    </div>
  );
}

export default function UserActionLogPage() {
  return <UserActionLogContent />;
}
